import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowDownLarge } from '@pets-ui/icons'
import { OverflowTooltip } from '@pets-ui/OverflowTooltip/OverflowTooltip'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsiveCustom } from '@pets-ui/useResponsive/useResponsive'
import type * as stylex from '@stylexjs/stylex'
import { type WpCartMobileMediaQuery } from '../WpCartLayout/useWpCartResponsive'

const MOBILE: WpCartMobileMediaQuery = '@media (max-width: 983px)'

export interface SelectProductVariantProps {
  children?: string
  disabled?: boolean
  onClick?: () => void
  error?: boolean
  rootStyle?: stylex.StyleXStyles
}

export const SelectProductVariant = (props: SelectProductVariantProps) => {
  const { children, disabled, onClick, error, rootStyle } = props
  const isClickable = !disabled && !!onClick
  const isMobile = useResponsiveCustom(MOBILE)

  return (
    <HStack
      role="button"
      alignItems="center"
      justifyContent="space-between"
      cursor={isClickable ? 'pointer' : 'default'}
      gap={2}
      borderRadius={4}
      backgroundColor={colors.grey100}
      py={1}
      px={1}
      flexWrap="nowrap"
      maxWidth={isMobile ? 200 : 240}
      onClick={onClick}
      borderWidth={error ? 1 : 0}
      borderColor={error ? colors.red600 : 'transparent'}
      borderStyle="solid"
      rootStyle={rootStyle}
    >
      {children && <OverflowTooltip text={children} />}
      {isClickable && <ArrowDownLarge color={colors.grey600} />}
    </HStack>
  )
}
